import React from 'react'
import { Flipped, Flipper } from 'react-flip-toolkit'

const isActive = el => el.className.match(/active/) || el.parentNode.className.match(/active/)

const easings = {
  easeOutExpo: 'all .4s cubic-bezier(0.19, 1, 0.22, 1)',
  smallBump: 'all .4s cubic-bezier(0.175, 0.885, 0.32, 1.75)',
  bigBump: 'all .4s cubic-bezier(0.175, 0.885, 0.32, 2.5)',
}
const wait = time => ({then: f => setTimeout(f, time)})
const animate = (el, options) => Object.assign(el.style, options)

const AnimatedSwap = ({ shown, extra = false, renderItem, name }) => {
  if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
    return (
      <div className="conversation-picker-main">
        { shown.map(renderItem) }
        { extra }
      </div>
    )
  }

  const onAppear = el => {
    el.style.opacity = 1
    const img = el.querySelector('.avatar')
    if (isActive(el)) {
      animate(img, { transform: 'scale(0.85)' })
      wait(100).then(() => animate(img, { transition: easings.bigBump, transform: 'scale(1)' }))
    } else {
      animate(img, { transform: 'scale(0.6)' })
      wait(100).then(() => animate(img, { transform: '' }))
    }
  }

  const onStart = el => {
    if (isActive(el)) {
      const img = el.querySelector('.avatar')
      animate(img, { transition: easings.smallBump, transform: 'scale(0.6)' })
      wait(400).then(() => animate(img, { transform: '' }))
    }
  }

  const onComplete = el => {
    if (!isActive(el)) {
      el.querySelector('.avatar').style.transition = ''
    }
  }

  return (
    <Flipper flipKey={shown.map(e => e.conversationUid).join('')} decisionData={shown} className={`conversation-picker-${name}`}>
      {shown.map(e => (
        <Flipped
          key={e.conversationUid}
          flipId={e.conversationUid}
           onAppear={onAppear}
           onStart={onStart}
           onComplete={onComplete}
        >
          { renderItem(e) }
        </Flipped>
      ))}
      { extra }
    </Flipper>
  )
}

export default AnimatedSwap
